"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var elements_1 = require("../elements");
var Image_1 = __importDefault(require("../elements/Image"));
var Footer_1 = require("../../defaults/Footer");
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var FooterDiv = styled_components_1.default.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  padding: 20px 0;\n  text-align: center;\n  .link-container {\n    a {\n      border-right: 1px solid #fff;\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n"], ["\n  background: ",
    ";\n  padding: 20px 0;\n  text-align: center;\n  .link-container {\n    a {\n      border-right: 1px solid #fff;\n      &:last-child {\n        border-right: none;\n      }\n    }\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, dark = _a.dark, theme = _a.theme;
    return backgroundColor ? backgroundColor : dark ? theme.bgDark : theme.bgLight;
});
var StyledLink = styled_components_1.default(react_router_dom_1.NavLink).withConfig({
    shouldForwardProp: function (prop) { return !['dark'].includes(prop); }
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  padding: 0 10px;\n  font-size: 14px;\n  margin: 0;\n  &:hover {\n    color: ", ";\n  }\n  &.active {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  padding: 0 10px;\n  font-size: 14px;\n  margin: 0;\n  &:hover {\n    color: ", ";\n  }\n  &.active {\n    color: ", ";\n  }\n"])), function (_a) {
    var color = _a.color, dark = _a.dark, theme = _a.theme;
    return _helpers_1.setFontColor(dark, color, theme);
}, function (props) { return props.theme.primary; }, function (props) { return props.theme.primary; });
var Footer = function (_a) {
    var _b = _a.dark, dark = _b === void 0 ? true : _b, backgroundColor = _a.backgroundColor, image = _a.image, links = _a.links, copyright = _a.copyright, text = _a.text, _c = _a.linkTo, linkTo = _c === void 0 ? '/' : _c;
    var mergedImageConfig = _helpers_1.merge(Footer_1.defaultImageConfig, image);
    return (react_1.default.createElement(FooterDiv, { dark: dark, backgroundColor: backgroundColor },
        react_1.default.createElement("div", { className: "container" },
            image && (react_1.default.createElement(react_router_dom_1.NavLink, { to: linkTo },
                react_1.default.createElement(Image_1.default, __assign({}, mergedImageConfig)))),
            react_1.default.createElement("div", { className: "link-container" }, links === null || links === void 0 ? void 0 : links.map(function (item, i) { return (react_1.default.createElement(StyledLink, __assign({ key: i, to: item.to, dark: dark }, item.config), item.title)); })),
            react_1.default.createElement(elements_1.Text, __assign({}, Footer_1.defaultCopyrightTextConfig, { text: copyright, dark: dark })),
            react_1.default.createElement(elements_1.Text, __assign({}, Footer_1.defaultInfoTextConfig, { text: text, dark: dark })))));
};
exports.default = Footer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Footer.js.map